module.exports = __webpack_public_path__ + "img/push.2c5fab9b.svg";